import React from "react"
import { Grid, Typography } from "@material-ui/core"

import { SvgIcon } from "@/components"

import { AIAgentIcon } from "@/assets/icons"

import useStyles from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListIdentity/styles"
import { colors } from "@/styles/colors"

type AgentListIdentityProps = {
	name: string
}

const AgentListIdentity: React.FC<AgentListIdentityProps> = (props) => {
	const { name } = props

	const classes = useStyles()

	return (
		<Grid container spacing={2} alignItems="center">
			<Grid item>
				<Grid container justifyContent="center">
					<SvgIcon
						className={classes.icon}
						icon={AIAgentIcon}
						style={{
							fill: colors.getPrimaryColor()
						}}
					/>
				</Grid>
			</Grid>
			<Grid item xs>
				<Grid container justifyContent="center">
					<Typography variant="h4" className={classes.listItemTitle}>
						{name}
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default AgentListIdentity
